import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';

export const getTextFieldOptions = ({ palette }: Theme) => {
  const textFieldComponents = {
    styleOverrides: {
      root: ({
        ownerState,
      }: {
        ownerState: {
          error?: boolean;
          size?: 'small' | 'medium';
        };
      }) => {
        const baseStyles = {
          [`& ${globalClasses.textFieldRoot}`]: {
            borderRadius: '100px',
            backgroundColor: 'transparent',
            transition: 'all 0.2s ease-in-out',

            ...(ownerState.size === 'medium' && {
              height: '48px',
            }),

            [`& ${globalClasses.textFieldFieldset}`]: {
              borderColor: palette.input.main,
              borderWidth: '1px',
            },
            [`&:hover ${globalClasses.textFieldFieldset}`]: {
              borderColor: palette.input.mainHover,
            },
            [`&${globalClasses.focused} ${globalClasses.textFieldFieldset}`]: {
              borderColor: palette.input.mainFocus,
              borderWidth: '2px',
            },

            ...(ownerState.error && {
              [`& ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.error.main,
              },
              [`&:hover ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.error.main,
              },
              [`&${globalClasses.focused} ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.error.main,
              },
            }),

            [`&${globalClasses.disabled}`]: {
              [`& ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.textField.borderDisabled,
              },
            },
          },
        };

        return {
          ...baseStyles,
        };
      },
    },
    defaultProps: {
      variant: 'outlined',
      size: 'medium',
    },
  };

  return { textFieldComponents };
};
